export default class WalletEvent {
    name = '';
    unique_key = '';
    metadata: any = {};
    provider: string = '';
}